import React from 'react';

const NextSteps = () => (
  <div className="space-y-6">
    <h2 className="text-2xl font-bold text-slate-800 dark:text-white mb-6">
      🚀 Next Steps
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-emerald-50 dark:bg-emerald-900/20 p-6 rounded-lg border border-emerald-200 dark:border-emerald-700">
        <h3 className="text-xl font-semibold text-emerald-800 dark:text-emerald-300 mb-3">
          📋 Book EMHA Assessment
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          On-site validation and detailed implementation planning
        </p>
        <button className="bg-emerald-600 dark:bg-emerald-500 text-white px-4 py-2 rounded-lg hover:bg-emerald-700 dark:hover:bg-emerald-600 transition-colors">
          Schedule EMHA
        </button>
      </div>
      <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg border border-blue-200 dark:border-blue-700">
        <h3 className="text-xl font-semibold text-blue-800 dark:text-blue-300 mb-3">
          🤝 Find Partners
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Connect with verified implementation partners
        </p>
        <button className="bg-blue-600 dark:bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors">
          Browse Partners
        </button>
      </div>
      <div className="bg-green-50 dark:bg-green-900/20 p-6 rounded-lg border border-green-200 dark:border-green-700">
        <h3 className="text-xl font-semibold text-green-800 dark:text-green-300 mb-3">
          💰 Explore Grants
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Grant matching portal for funding opportunities
        </p>
        <button className="bg-green-600 dark:bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition-colors">
          Find Grants
        </button>
      </div>
      <div className="bg-purple-50 dark:bg-purple-900/20 p-6 rounded-lg border border-purple-200 dark:border-purple-700">
        <h3 className="text-xl font-semibold text-purple-800 dark:text-purple-300 mb-3">
          🎯 Integrate with LEAP
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mb-4">
          Leadership Energy Assessment Programme overview
        </p>
        <button className="bg-purple-600 dark:bg-purple-500 text-white px-4 py-2 rounded-lg hover:bg-purple-700 dark:hover:bg-purple-600 transition-colors">
          Learn About LEAP
        </button>
      </div>
    </div>
  </div>
);

export default NextSteps;


